export default "__VITE_ASSET__44aDLC0K__"